import { render, staticRenderFns } from "./DefectDetail.vue?vue&type=template&id=dd476d5a"
import script from "./DefectDetail.vue?vue&type=script&lang=js"
export * from "./DefectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports